import React from "react";
import { Button } from "react-bootstrap";
import { _t, isEn } from "../../../app/i18n/i18n";
import { formatInt } from "lib/numberFormat";

export const FilterSearchButton = ({ results = {}, onClick }) => (
  <section className="text-center">
    <Button onClick={onClick} type="submit" disabled={results.TotalRecords === 0} className="my-2">
      {<i className="fa fa-search fa-fw mr-2" />}
      {_t("Please search")}
      &nbsp;
      {Number.isInteger(results.TotalRecords) ? formatInt(results.TotalRecords) + " " : ""}
      {isEn() ? "publications" : ""}
    </Button>
  </section>
);
